import React from 'react';
import { RadioGroup } from '..';
import Wrapper from './style';

const Index = (props) => {
  const { setSelectedRadio, selectedRadio, radioOptions = [] } = props;
  return (
    <Wrapper>
      <div className="font-paragraph_medium black2">Campaign Objective</div>
      <div className="container_select_campaign_objective">
        {radioOptions.map((item) => {
          return (
            <div
              className="component_select_campaign_objective_item"
              key={item?.key}
            >
              <div className="font-caption black2 component_title">
                {item?.title}
              </div>
              <RadioGroup
                radioOptions={item?.options}
                radioLayout="vertical"
                selectedRadio={selectedRadio}
                setSelectedRadio={setSelectedRadio}
              />
            </div>
          );
        })}
      </div>
    </Wrapper>
  );
};

export default Index;
